<template>
  <Wrapper>
    <div class="container-fluid pb-0">
      {{ $auth.check() }}
      {{ $auth.user() }}
      <AccountStats />
      <hr>
      <AccountVideos />
      <hr class="mt-0">
      <AccountChannels />
    </div>
  </Wrapper>
</template>

<script>
export default {
  components: {
    AccountStats: () => import('@/components/account/AccountStats'),
    AccountVideos: () => import('@/components/account/AccountVideos'),
    AccountChannels: () => import('@/components/account/AccountChannels'),
  },
};
</script>
